import * as formatHelper from "../../helpers/formatHelper";

/**
 * @class Customer
 *
 * @property {Number}           id
 * @property {String}           name
 */
export default class Customer {
    /**
     * @param {Number} id
     * @param {String} name
     */
    constructor(id, name) {
        this._id = id;
        this._name = name;
        this._phone = "";
        this._email = "";
        this._street = "";
        this._city = "";
        this._zipCode = "";
        this._barcode = "";
        this._marginId = null;
        this._marginName = "";
        this._identification = null;
        this._country = "";
        this._expirationDate = null;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Customer");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String | null}
     */
    get phone() {
        return this._phone;
    }

    /**
     * @param {String | null}   phone
     */
    set phone(phone) {
        this._phone = phone;
    }

    /**
     * @return {String | null}
     */
    get email() {
        return this._email;
    }

    /**
     * @param {String | null}   email
     */
    set email(email) {
        this._email = email;
    }

    /**
     * @return {String | null}
     */
    get street() {
        return this._street;
    }

    /**
     * @param {String | null}   street
     */
    set street(street) {
        this._street = street;
    }

    /**
     * @return {String | null}
     */
    get city() {
        return this._city;
    }

    /**
     * @param {String | null}   city
     */
    set city(city) {
        this._city = city;
    }

    /**
     * @return {String | null}
     */
    get country() {
        return this._country;
    }

    /**
     * @param {String | null}   country
     */
    set country(country) {
        this._country = country;
    }

    /**
     * @return {String | null}
     */
    get zipCode() {
        return this._zipCode;
    }

    /**
     * @param {String | null}   zipCode
     */
    set zipCode(zipCode) {
        this._zipCode = zipCode;
    }

    /**
     * @return {String | null}
     */
    get barcode() {
        return this._barcode;
    }

    /**
     * @param {String | null}   barcode
     */
    set barcode(barcode) {
        this._barcode = barcode;
    }

    /**
     * @return {String | null}
     */
    get identification() {
        return this._identification;
    }

    /**
     * @param {String | null}   identification
     */
    set identification(identification) {
        this._identification = identification;
    }

    /**
     * @return {Number | null}
     */
    get marginId() {
        return this._marginId;
    }

    /**
     * @param {Number | null}   marginId
     */
    set marginId(marginId) {
        this._marginId = marginId;
    }

    /**
     * @return {String | null}
     */
    get marginName() {
        return this._marginName;
    }

    /**
     * @param {String | null}   marginName
     */
    set marginName(marginName) {
        this._marginName = marginName;
    }

    /**
     * @return {Date | null}
     */
    get expirationDate() {
        return this._expirationDate;
    }

    /**
     * @param {Date | null} expirationDate
     */
    set expirationDate(expirationDate) {
        this._expirationDate = expirationDate;
    }

    /**
     * @return {String}
     */
    formatExpirationDate() {
        if (this._expirationDate === null) {
            return "";
        }

        return formatHelper.formatDateUtc(this._expirationDate);
    }

    /**
     * @return {String}
     */
    getExpirationDays() {
        if (this._expirationDate === null) {
            return 0;
        }

        let expiration = new Date(this._expirationDate);
        let now = new Date();

        return Math.floor((expiration.getTime() - now.getTime()) / 86400000);
    }

    /**
     * @return {String}
     */
    toString() {
        return "Customer (" + this._id + ")";
    }

    /**
     * @return {Object}
     */
    formatedObject() {
        return {
            id: this._id,
            name: this._name,
            phone: this._phone,
            email: this._email,
            street: this._street,
            city: this._city,
            zipCode: this._zipCode,
            barcode: this._barcode,
            marginId: this._marginId,
            marginName: this._marginName,
            identification: this._identification,
            country: this._country
        };
    }
}
